import {map} from 'lodash-es';
import {OverviewMachineColoredYarnSet} from './overview-machine-colored-yarn-set';

export class OverviewMachineCreel {
  public _id: number;
  public _name: string;
  public _creelColoredYarnSets: OverviewMachineColoredYarnSet[];

  public constructor(id: number = null, name: string = null, creelColoredYarnSets: OverviewMachineColoredYarnSet[] = []) {
    this._id = id;
    this._name = name;
    this._creelColoredYarnSets = creelColoredYarnSets;
  }

  public static fromJSON(creelJSON: any): OverviewMachineCreel {
    return new OverviewMachineCreel(
      creelJSON.id,
      creelJSON.name,
      map(creelJSON.creelColoredYarnSets, (coloredYarnSet: any) => new OverviewMachineColoredYarnSet(coloredYarnSet.coloredYarnSetId, coloredYarnSet.coloredYarnSetName, coloredYarnSet.startDent))
    );
  }

  public get id(): number {
    return this._id;
  }

  public set id(id: number) {
    this._id = id;
  }

  public get name(): string {
    return this._name;
  }

  public set name(name: string) {
    this._name = name;
  }

  public get creelColoredYarnSets(): OverviewMachineColoredYarnSet[] {
    return this._creelColoredYarnSets;
  }

  public set creelColoredYarnSets(creelColoredYarnSets: OverviewMachineColoredYarnSet[]) {
    this._creelColoredYarnSets = creelColoredYarnSets;
  }
}
